import React, { useState, useEffect } from 'react';
import { Grid2, TextField, Box, Button } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const KitchenEquipmentForm = ({ apartmentId, token }) => {
  const { t } = useTranslation();
  const [equipment, setEquipment] = useState({
    plates_bowls_utensils: 0,
    glasses_mugs: 0,
    pots_pans: 0,
    cooking_utensils: 0,
    cutting_board_knives: 0,
    mixing_bowls: 0,
    can_opener: 0,
    measuring_cups_spoons: 0,
  });

  const [isNewEntry, setIsNewEntry] = useState(false);

  useEffect(() => {
    const fetchEquipment = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/kitchenequipment/${apartmentId}/`);
        setEquipment(response.data);
        setIsNewEntry(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setIsNewEntry(true);
        } else {
          console.error('Error fetching kitchen equipment data:', error);
        }
      }
    };

    fetchEquipment();
  }, [apartmentId]);

  const handleQuantityChange = (field, value) => {
    setEquipment(prevEquipment => ({
      ...prevEquipment,
      [field]: Number(value),
    }));
  };

  const handleSubmit = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/api/kitchenequipment/${apartmentId}/`;

      // Create FormData instance
      const formData = new FormData();
      for (const key in equipment) {
        formData.append(key, equipment[key]);
      }

      if (isNewEntry) {
        // Create new KitchenEquipment entry
        await axios.post(url, formData, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        // Update existing KitchenEquipment entry
        await axios.put(url, formData, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
      }

      alert('Kitchen equipment data saved successfully!');
    } catch (error) {
      console.error('Error saving kitchen equipment data:', error);
      alert('Failed to save kitchen equipment data. Please try again.');
    }
  };

  return (
    <Grid2 container spacing={2}>
      {Object.keys(equipment).map(key => (
        <Grid2 item xs={12} sm={6} md={3} key={key}>
          <Box display="flex" alignItems="center">
            <TextField
              id={`${key}-input`}
              name={key}
              label={t(`kitchenEquipment.${key}`)}
              type="number"
              value={equipment[key]}
              onChange={(e) => handleQuantityChange(key, e.target.value)}
              fullWidth
              margin="normal"
              //InputProps={{ inputProps: { min: 0 } }}
            />
          </Box>
        </Grid2>
      ))}
      <Grid2 item xs={12}>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Grid2>
    </Grid2>
  );
};

export default KitchenEquipmentForm;
